<template>
    <section class="p-[16px]">
        <div class="mb-[16px] flex items-center justify-between">
            <h2 class="text-[18px] text-[#2b2b2b] font-light">Gestion des zones</h2>
        </div>
        <div class="grid grid-cols-5 gap-3 my-3 text-black">
            <div class="w-full flex flex-col">
                <label for="label" class="font-light">Label</label>
                <input type="text" v-model="zonedata.label" class="w-full h-[36px] font-light rounded-lg border p-3">
            </div>
            <div class="w-full flex flex-col">
                <label for="latitude" class="font-light">Latitude</label>
                <input type="text" v-model="zonedata.latitude" class="w-full h-[36px] font-light rounded-lg border p-3">
            </div>
            <div class="w-full flex flex-col">
                <label for="longitude" class="font-light">Longitude</label>
                <input type="text" v-model="zonedata.longitude" class="w-full h-[36px] font-light rounded-lg border p-3">
            </div>
            <div class="w-full flex flex-col">
                <label for="radius" class="font-light">Radius</label>
                <input type="text" v-model="zonedata.radius" class="w-full h-[36px] font-light rounded-lg border p-3">
            </div>
            <div class="w-full flex flex-col justify-end">
                <button v-on:click="addZone" className="flex font-light items-center justify-center h-[36px] px-8 rounded-xl text-white bg-[#3c41e9]">
                    <Plus v-if="!asSend" :size="16" strokeWidth="1.3"/>
                    <Loader2 v-else :size="16" strokeWidth="1.3" class="animate-spin"/>
                    <span class="ml-[6px]">Ajouter une zone</span>
                </button>
            </div>
        </div>
        <div class="w-full bg-gray-50 rounded-xl overflow-hidden relative">
            <div class="absolute top-[10px] text-[#2b2b2b] left-1/2 -translate-x-1/2 z-10 w-[35%] p-[2px] bg-white rounded-xl">
                <GMapAutocomplete
                    placeholder="Recherchez un lieu..."
                    @place_changed="setPlace"
                    class="h-[40px] border w-full rounded-xl p-3"
                    :options="{ fields: ['geometry', 'formatted_address', 'name']}"
                />
            </div>
            <GMapMap
                :center="center"
                :zoom="zoom"
                map-type-id="roadmap"
                style="width: 100%; height: 500px"
                :ref="mapRef"
                @click="handleMapClick"
            >
                <Marker :key="index" v-for="(m, index) in markers" :position="m.position" :draggable="false"/>
                <Circle :key="index" v-for="(info,index) in rayonsInfo" :options="info" />
            </GMapMap>
        </div>
        <div class="mt-5">
            <CustomTable :data="zones" :columnsCustom="columnn" :load="table_load">
                <template #row-cell="slotProps">
                    <span v-if="slotProps.cellNumber == 4">
                        <RemoveZone :id="slotProps.value" @child-action="getZones"/>
                    </span>
                    <span v-else>{{ slotProps.value }}</span>
                </template>
            </CustomTable>
        </div>

    </section>
</template>

<script>
import {Plus,Loader2} from "lucide-vue-next";
import Swal from 'sweetalert2'
import API from "../../service/API.js";
import CustomTable from "./../../components/tables/Custom-table.vue";
import {createColumnHelper} from "@tanstack/vue-table";
import RemoveZone from "../../components/btn/remove-zone.vue"
import { Marker, Circle } from '@fawmi/vue-google-maps';

const columnHelper = createColumnHelper();
const columnsRequest = [
  columnHelper.accessor(row => row.label, {
    id: 'label',
    header: 'Label',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row.longitude, {
    id: 'longitude',
    header: 'Longitude',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row.latitude, {
    id: 'latitude',
    header: 'Latitude',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row.radius, {
    id: 'rayon',
    header: 'Rayon',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row.id, {
    id: 'action',
    header: '',
    cell: info => info.getValue(),
  })
]

export default {
    name: 'ZonesView',
    components: {
        Plus,
        Loader2,
        CustomTable,
        RemoveZone,
        Marker, Circle
    },
    data() {
        return {
            zonedata: { label: null, latitude: null, longitude: null, radius: null },
            chosenEmployeeId: "",
            chosenZoneId: null,
            infowindow: null,
            unemployees: [],
            employees: null,
            asSend: false,
            table_load: false,
            zones: [],
            markers: [],
            rayonsInfo: [],
            columnn: columnsRequest,
            map: null,
            center: {lat: 5.3252076063163685, lng: -4.019592271163943},
            zoom: 10,
            mapRef: null,
        }
    },
    mounted() {
        this.getZones();
    },
    methods: {
        setPlace(place){
            if (place.geometry) {
                this.center = {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng(),
                };
                this.zoom = 9;
            }
        },
        handleMapClick(event){
            const latLng = event.latLng;
            const coordinates = {
                lat: latLng.lat(),
                lng: latLng.lng(),
            };
            this.zonedata = {
                ...this.zonedata,
                latitude: coordinates.lat,
                longitude: coordinates.lng
            }
        },
        getZones() {
            this.table_load = true
            API.get('/getAllZones')
                .then((res) => {
                    if(res.status != 200) throw Error("Une erreur inattendue s'est produite sur le serveur. Nous travaillons à la résoudre.")
                    this.zones = res.data.data;
                    const data = [];
                    const dt = [];
                    res.data.data.forEach(element => {
                        data.push({
                            position: {
                                lat: element.latitude, lng: element.longitude
                            },
                        });
                        dt.push({
                            center: {lat: element.latitude, lng: element.longitude},
                            radius: element.radius,
                            options: {
                                strokeColor: '#FF0000',
                                strokeOpacity: 0.8,
                                strokeWeight: 2,
                                fillColor: '#FF0000',
                                fillOpacity: 0.35,
                                editable: false,
                                clickable: false,
                            },
                        })
                    });
                    this.rayonsInfo = [...dt];
                    this.markers = [...data];
                })
                .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
                .finally(()=> (this.table_load = false))
        },
        async updateZone(id, label, latitude, longitude, radius, code) {
            Swal.fire({
                title: "Confirmer la modification",
                text: "",
                icon: 'warning',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Je confirme !',
                cancelButtonText: "J'annule",
                showCancelButton: true
            }).then(async (result) => {
                if (result.isConfirmed) {
                    console.log({
                        label: label,
                        latitude: latitude,
                        longitude: longitude
                    })
                    API.post('/updateZone/' + id,
                        {
                            label: label,
                            latitude: latitude,
                            longitude: longitude,
                            radius: radius,
                            code: code,
                        })
                        .then(async (res) => {
                            if (res.data.status) {
                                await Swal.fire(
                                    {
                                        title: 'Succès !',
                                        text: 'Zone modifiée',
                                        icon: 'success',
                                    }
                                ).then(() => {
                                    window.location.reload()
                                })
                            } else {
                                Swal.fire(
                                    'Oops..',
                                    res.data.message,
                                    'error'
                                )
                            }
                        })
                        .catch((error) => {
                            Swal.fire(
                                'Oops..',
                                error.response.data.message,
                                'error'
                            )
                            console.error(error)
                        })
                }
            })

        },

        async removeZone(id) {
            Swal.fire({
                title: "Confirmer la suppression",
                text: "Cette action est ireversible",
                icon: 'warning',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Je confirme !',
                cancelButtonText: "J'annule",
                showCancelButton: true
            }).then(async (result) => {
                if (result.isConfirmed) {
                    API.post('/removeZone/' + id)
                        .then(async (res) => {
                            if (res.data.status) {
                                await Swal.fire(
                                    {
                                        title: 'Succès !',
                                        text: 'Zone supprimeé',
                                        icon: 'success',
                                    }
                                ).then(() => {
                                    window.location.reload()
                                })
                            } else {
                                Swal.fire(
                                    'Oops..',
                                    res.data.message,
                                    'error'
                                )
                            }
                        })
                        .catch((error) => {
                            console.error(error)
                            this.table_load = false
                        })
                }
            })

        },

        async addZone() {
            this.asSend = true;
            API.post('/addZone', this.zonedata)
                .then(async (res) => {
                    if (!res.data.status)  throw Error(res.data?.message ?? "Erreur survenue durant l'opération, merci de contacter l'administrateur");
                    Swal.fire('Success',"Zone enregistrer",'success');
                    this.getZones();
                    this.zonedata = {
                        label: "",
                        latitude: "",
                        longitude: "",
                        radius: "",
                    }
                }).catch((e)=> Swal.fire('Erreur',e.message,'error'))
                .finally(()=>{
                    this.asSend = false;
            })
        },

        showplace(id, coordinates, employees, unemployees) {
            this.chosenZoneId = id
            this.employees = employees
            this.unemployees = unemployees
            this.map.setCenter(coordinates);
        },
    }
}

</script>